import React from 'react'
import * as FeatherIcon from 'react-feather'
import Loading from '../../Loading'
import './index.scss'

/**
 * 
 * @param {String} size - small, medium, large
 * @param {Boolean} contained - variation contained
 * @param {Boolean} outlined - variation outlined
 * @param {Boolean} disabled - disable button
 * @param {String} icon - Feather icon name
 * @param {Boolean} iconRight - Align icon to right
 * @param {Boolean} fullWidth - full width
 * @param {Boolean} loading
 * @param {Boolean} sizeIcon - size of icon
 * @param {Boolean} textUppercase - TextTransform of text
 * @param {Boolean} rounded - borderRadius 50%
 * @param {Boolean} onlyIcon - button only icon
 * @returns 
 */
function Button({ children = "", icon = "", iconRight = false, disabled = false, contained = false, outlined = false, color = "green", size = "small", loading = false, fullWidth = false, textUppercase = true, sizeIcon = 24, rounded, onlyIcon = false, ...props }) {

  function setClassName() {
    let className = "button"
    if (size) className += ` button--${size}`
    if (loading) className += " button--loading"
    if (iconRight) className += " button--icon-right"
    if(rounded) className += " button--rounded"
    if (onlyIcon) className += " button--onlyIcon"
    if (contained) className += ` button--contained--${color}`
    else if (outlined) className += ` button--outlined--${color}`
    else className += ` button--text--${color}`
    return className
  }

  const CustomIcon = ({sizeIcon}) => {
    const Icon = FeatherIcon[icon]
    return <Icon size={sizeIcon}/>
  }

  return (
    <button 
    className={setClassName()} 
    disabled={disabled} 
    style={{ 
      width: fullWidth ? "100%" : "fit-content", 
      textTransform: textUppercase ? 'uppercase' : 'unset' 
    }} 
    {...props}
    >
      {!loading && icon && <CustomIcon sizeIcon={sizeIcon}/>}
      {!loading && children}
      {loading && <Loading />}
    </button>
  )
}

export default Button
